document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', () => {
        const headerWrapper = document.querySelector('.header-wrapper'); // 使用选择器获取元素
        const scrollPosition = window.scrollY;
 const backgroundOverlay = document.querySelector('.indexscoll');

        if (headerWrapper) { // 检查 headerWrapper 是否存在
            // 判断滚动位置
            if (scrollPosition > 200) {
                headerWrapper.classList.remove('color-scheme-4'); // 移除 color-scheme-4
                headerWrapper.classList.add('color-scheme-1');   // 添加 color-scheme-1
                
                // 添加 indexscoll 类以显示背景图
                // if (!headerWrapper.classList.contains('indexscoll')) {
                //     headerWrapper.classList.add('indexscoll');
                // }
               backgroundOverlay.style.opacity = '1';
            } else {
                headerWrapper.classList.remove('color-scheme-1'); 
                headerWrapper.classList.add('color-scheme-4');


                // headerWrapper.classList.remove('indexscoll');
            }
        }
    });
});